export default "__VITE_ASSET__5267709e__"